import React from 'react';
import { useAuthStore } from '@/store/auth';
import { useChatStore, useChatInputStore } from '@/store';
import { findChatById } from '@/lib/chatIndex';
import { getStorage } from '@/store/storage';
import InteractiveAnswerView from './InteractiveAnswerView';

export default function InteractiveAnswer(props) {
  const userId = useAuthStore(state => state.user?.id);
  const chat = useChatStore(state => findChatById(state.chats, props.conversationId));
  const onFollowUp = text => {
    const composer = useChatInputStore.getState();
    composer.setContext(props.conversationId);
    // Prepare an editable draft; normal send/consent guards still own submission.
    if (!(useChatInputStore.getState().inputStates?.[props.conversationId]?.text || '').trim()) composer.setText(text);
  };
  return <InteractiveAnswerView {...props} userId={userId} canPersist={chat?.isOwner === true && !chat?.flags?.isTemporary}
    media={chat?.messages || []} getStorage={getStorage} onFollowUp={onFollowUp} />;
}
